import {concatPath, isNotEmpty} from "./strings";

/**
 * コンテキストパスを考慮したルートからのURLを取得する
 */
export function url(url_path) {
  if (isNotEmpty(url_path)) {
    // noinspection HttpUrlsUsage
    if(url_path.indexOf("http://") === 0 || url_path.indexOf("https://") === 0) {
      return url_path;
    } else {
      // eslint-disable-next-line no-undef
      return concatPath(_BASE_URL, url_path);
    }
  }
  return url_path;
}


/**
 * パラメータ無しのURLを取得する
 */
export function getCurrentRootRelativePath() {
  return getRootRelative(location.href, true,  true);
}

/**
 * ルート相対パスを取得
 * @param {string} path 取得元のパス
 * @param {boolean} excludeQueryString クエリパラメータを除く（削除する）かどうか
 * @param {boolean} excludeHashFragment ハッシュフラグメントを除く（削除する）かどうか
 * @return {string} 取得したルート相対パスを返す
 */
function getRootRelative(path, excludeQueryString, excludeHashFragment) {
  if (!path || !path.match(/(^\/|\/\/)/)) return '';

  let rPath = path.replace(/\\/g, '/').replace(/^[^/]*\/\/[^/]*/, '');

  if (excludeQueryString) rPath = rPath.replace(/\?([^#]+)?/, '');
  if (excludeHashFragment) rPath = rPath.replace(/#.*?$/, '');

  return rPath;
}


/**
 * 外部サイトへリダイレクトする
 */
export function redirectTo(url) {
  window.location.href = url;
}